import { useCallback, useEffect, useState } from "react";
import { clockingApi } from "@/network/network.jsx";
import type { ClockingAccess } from "../types";

export function useClockingAccess(boardId: number | string | null | undefined) {
  const [access, setAccess] = useState<ClockingAccess | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (boardId == null) {
      setAccess(null);
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const { data } = await clockingApi(boardId).getAccess();
      setAccess(data as ClockingAccess);
    } catch (err: unknown) {
      const message =
        (err as { response?: { data?: { error?: string } } })?.response?.data?.error ||
        "Unable to load clocking access.";
      setError(message);
      setAccess(null);
    } finally {
      setIsLoading(false);
    }
  }, [boardId]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { access, isLoading, error, refresh };
}
